import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import HomeEstimatedValue from "@/components/shared/HomeEstimatedValue";
import DepositEstimatedValue from "@/components/shared/DepositEstimatedValue";
import DepositBoostShare from "@/components/shared/DepositBoostShare";
import { HomeownershipAcceleratorForm } from "@/model/interface/CalculatorTypes";
import { ApplicationType } from "@/enum/ApplicationType";
import ProductShareInformation from "@/components/shared/ProductShareInformation";
import { useTitle } from "@/components/provider/TitleProvider";
import { isDebugForms } from "@/util/debug";

const UpfrontBoostCalculator = () => {
  const navigate = useNavigate();
  const { title, setTitle } = useTitle();

  useEffect(() => {
    setTitle("");
  }, []);

  const form = useForm<HomeownershipAcceleratorForm>({
    mode: "onTouched",
    defaultValues: {},
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form;

  const onSubmit = (data: HomeownershipAcceleratorForm) => {
    navigate("/upfront-boost/register");
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isDebugForms()) {
      navigate("/upfront-boost/register");
    } else {
      handleSubmit(onSubmit)(e);
    }
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={handleFormSubmit}>
        <div className="w-full max-w-2xl mx-auto px-4 py-6 space-y-6">
          <h3 className="text-4xl font-semibold text-gray-900">Upfront Boost Calculator</h3>
          <HomeEstimatedValue fieldPrefix="context" />
          <DepositEstimatedValue fieldPrefix="context" />
          <DepositBoostShare fieldPrefix="context" />
          <ProductShareInformation applicationType={ApplicationType.HomeownershipAccelerator} fieldPrefix={"context"} />
          <div className="flex justify-center pt-2">
            <button
              type="submit"
              className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
            >
              Get Started
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

UpfrontBoostCalculator.propTypes = {};

export default UpfrontBoostCalculator;
